import { PaletteSwatchIcon } from './PaletteSwatchIcon';

/**
 * author: Google
 * id 158F8306-CE63-45E8-94E5-58484FF5F050
 * name palette-swatch
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/palette-swatch.svg
 * tags
 * - Drawing / Art 
 * - Color 
 */
export const StyleIcon = PaletteSwatchIcon;
export default StyleIcon